
<div class="container p-4">
    <div class="row">
        <h4 class="head">Filter Products</h4>
    </div>
    <form [formGroup]="productFilterForm">
        <div class="row">
          <div class="col-lg-4 mt-4" >
            <div >
                <mat-label class="label">Added On</mat-label>
            </div>
            <div>
                <mat-form-field appearance="outline" class="fields w-100">
                    <mat-date-range-input [rangePicker]="picker">
                        <input
                          matStartDate
                          placeholder="Start"
                          formControlName="startDate"
                        />
                        <input matEndDate placeholder="End" formControlName="endDate" />
                      </mat-date-range-input>
                      <mat-datepicker-toggle
                        matIconSuffix
                        [for]="picker"
                      ></mat-datepicker-toggle>
                      <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
            </div>
        </div>
            <div class="col-lg-4 mt-4" >
                <div >
                    <mat-label class="label">All OEM</mat-label>
                </div>
                <div>
                    <mat-form-field appearance="outline" class="fields w-100">
                            <input color="primary" 
                            matInput
                                placeholder="Select"
                                class="custom-select-input"
                                formControlName="startWith"
                                [matAutocomplete]="auto"
                                (keydown.enter)="loadOEM()"
                                (click)="loadOEM()"
                                />
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOEMChange($event)">
                            <mat-option *ngFor="let om of oems" [value]="om">{{ om.companyName }}</mat-option> 
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-lg-3 mt-4">
                <div>
                  <mat-label class="label">Primary Category</mat-label>
                </div>
                <div>
                  <mat-form-field appearance="outline" class="fields w-100">
                    <input type="text" formControlName="primaryCategory" placeholder="Select" matInput [matAutocomplete]="categoryDropdown" (input)="getCategoryDropdown($event)">
                    <mat-autocomplete #categoryDropdown="matAutocomplete" (optionSelected)="onPrimaryCategoryChange($event.option.value)">
                      <mat-option *ngFor="let category of filteredCategories" [value]="category.name">
                        {{ category.name }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </div>
              
              <div class="col-lg-3 mt-4">
                <div>
                  <mat-label class="label">Secondary Category</mat-label>
                </div>
                <div>
                  <mat-form-field appearance="outline" class="fields w-100">
                    <input type="text" formControlName="secondaryCategory" placeholder="Select" matInput [matAutocomplete]="secondaryCategoryDropdown" (input)="getSecondaryCategoryDropdown($event)">
                    <mat-autocomplete #secondaryCategoryDropdown="matAutocomplete" (optionSelected)="onSecondaryCategoryChange($event.option.value)">
                      <mat-option *ngFor="let secondCategory of filteredSecondaryCategories" [value]="secondCategory.name">
                        {{ secondCategory.name }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </div>
              
              <div class="col-lg-3 mt-4">
                <div>
                  <mat-label class="label">Tertiary Category</mat-label>
                </div>
                <div>
                  <mat-form-field appearance="outline" class="fields w-100">
                    <input type="text" formControlName="tertiaryCategory" placeholder="Select" matInput [matAutocomplete]="tertiaryCategoryDropdown" (input)="getTertiaryCategoryDropdown($event)">
                    <mat-autocomplete #tertiaryCategoryDropdown="matAutocomplete" (optionSelected)="onTertiaryCategoryChange($event.option.value)">
                      <mat-option *ngFor="let thirdCategory of filteredTertiaryCategories" [value]="thirdCategory.name">
                        {{ thirdCategory.name }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </div>
              
              <div class="col-lg-3 mt-4">
                <div>
                  <mat-label class="label">Quaternary Category</mat-label>
                </div>
                <div>
                  <mat-form-field appearance="outline" class="fields w-100">
                    <input type="text" formControlName="quaternaryCategory" placeholder="Select" matInput [matAutocomplete]="quaternaryCategoryDropdown" (input)="getQuaternaryCategoryDropdown($event)">
                    <mat-autocomplete #quaternaryCategoryDropdown="matAutocomplete" (optionSelected)="onQuaternaryCategoryChange($event.option.value)">
                      <mat-option *ngFor="let fourthCategory of filteredQuaternaryCategories" [value]="fourthCategory.name">
                        {{ fourthCategory.name }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </div>
              
            <!-- <div class="col-lg-4" >
                <div >
                    <mat-label class="label">Status</mat-label>
                </div>
                <div>
                    <mat-form-field appearance="outline" class="fields w-100">
                        <mat-select placeholder="Select" formControlName="status">
                            <mat-option *ngFor="let status of status" [value]="status.value">
                                {{status.label}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div> -->
             
            <!-- <div class="col-lg-4" >
                <div >
                    <mat-label class="label">Created By</mat-label>
                </div>
                <div>
                    <mat-form-field appearance="outline" class="fields w-100">
                        <mat-select placeholder="Select" formControlName="createdBy">
                            <mat-option *ngFor="let createdBy of users" [value]="createdBy.id">
                                {{ createdBy?.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div> -->
        </div>

        <div *ngIf="chips?.length" class="row-container-2 mt-4">
          <span class="paragraph-medium">Filters applied: </span>
          <mat-chip class="chip-item mt-2" *ngFor="let chip of chips" (removed)="removeChip(chip)">
            {{ chip }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        </div>

        <div class="row mt-4 d-flex">
            <div class="col-lg-1">
                <button class="buttons p-2" (click)="filterProduct()">Filter</button>
            </div>
            <div  class="col-lg-1 " >
                <button class="cbuttons p-2" (click)="clearFilter()">Clear</button>
            </div>
            <div  class="col-lg-2 " >
                <button class="cbuttons p-2 " (click)="closeDialog()">Clear & Cancel</button>
            </div>
        </div>
</form>
</div>